// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZoneUI_view__L2iU8 {
  padding: 24px;
  font-family: 'Inter', Roboto, Arial, sans-serif;
}

/* Typography and Layout Wrappers */

.ZoneUI_formWrapper__DsniZ {
  margin-top: 24px;
}

.ZoneUI_formCard__amgGL {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
  padding: 32px 24px;
  height: 100%;
  border: 1px solid #f1f5f9;
}

.ZoneUI_mapCard__-Hbvt {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);
  padding: 16px;
  height: 100%;
  min-height: 600px;
  border: 1px solid #f1f5f9;
  display: flex;
  flex-direction: column;
}

.ZoneUI_mapContainerWrap__YvFAp {
  flex-grow: 1;
  border-radius: 12px;
  overflow: hidden;
  /* Subtly separate the map from the white card */
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  min-height: 500px; /* Guarantee a minimum height */
}

.ZoneUI_mapContainerWrap__YvFAp > div {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.ZoneUI_label__Mbpee {
  font-size: 12px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: inline-block;
}

.ZoneUI_itemColumn__KjKRA {
  margin-bottom: 24px;
}

.ZoneUI_itemSubmit__\\+qtuE {
  margin-top: 32px;
}

/* Inputs customization */

.ZoneUI_input__uMdO\\+ {
  border-radius: 8px !important;
}

.ZoneUI_input__uMdO\\+ .ant-select-selector,
.ZoneUI_input__uMdO\\+ .ant-input,
.ZoneUI_input__uMdO\\+.ant-input-affix-wrapper {
  border-radius: 8px !important;
  border-color: #cbd5e1 !important;
  background-color: #f8fafc !important;
  transition: all 0.2s ease !important;
}

.ZoneUI_input__uMdO\\+ .ant-select-selector:hover,
.ZoneUI_input__uMdO\\+.ant-input-affix-wrapper:hover,
.ZoneUI_input__uMdO\\+ .ant-input:hover {
  border-color: #94a3b8 !important;
  background-color: #ffffff !important;
}

.ZoneUI_input__uMdO\\+ .ant-select-selector:focus,
.ZoneUI_input__uMdO\\+.ant-input-affix-wrapper-focused,
.ZoneUI_input__uMdO\\+ .ant-input:focus {
  border-color: #f97316 !important; /* Brand orange focus */
  box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1) !important;
  background-color: #ffffff !important;
}

/* Original Brand Button without gradients or neon */

.ZoneUI_submit__6u\\+cm {
  width: 100%;
  border-radius: 8px !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  height: 48px !important;
  font-size: 15px !important;
  /* Keeping solid brand colors */
}

/* Secondary Button (Upload) */

.ZoneUI_uploadImage__3GjPx {
  border-radius: 8px;
  height: 38px;
  padding: 0 16px;
  font-weight: 600;
  color: #f97316;
  border: 1px solid #f97316;
  background: transparent;
  transition: all 0.2s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ZoneUI_uploadImage__3GjPx:hover {
  color: #ffffff;
  background: #f97316;
  border-color: #f97316;
}

.ZoneUI_mapActions__\\+S25L {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.ZoneUI_exportBtn__WPjcu {
  border-radius: 8px;
  height: 38px;
  padding: 0 16px;
  font-weight: 600;
  color: #64748b;
  border: 1px solid #cbd5e1;
  background: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.ZoneUI_exportBtn__WPjcu:hover {
  color: #334155;
  border-color: #94a3b8;
  background: #f8fafc;
}

.ZoneUI_center__D5dfS {
  display: block;
  font-size: 12px;
  color: #94a3b8;
  margin-top: 8px;
}

/* Top bar actions */

.ZoneUI_actions__O8xyn {
  display: flex;
  align-items: center;
  gap: 16px;
}

.ZoneUI_switchWrap__UnQRw {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #334155;
}

.ZoneUI_loader__NQB\\+9 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}
`, "",{"version":3,"sources":["webpack://./src/pages/zone-detail/styles/ZoneUI.module.css"],"names":[],"mappings":"AAAA;EACI,aAAa;EACb,+CAA+C;AACnD;;AAEA,mCAAmC;;AACnC;EACI,gBAAgB;AACpB;;AAEA;EACI,mBAAmB;EACnB,mBAAmB;EACnB,kFAAkF;EAClF,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC7B;;AAEA;EACI,mBAAmB;EACnB,mBAAmB;EACnB,kFAAkF;EAClF,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;AAC1B;;AAEA;EACI,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gDAAgD;EAChD,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,+BAA+B;AACtD;;AAEA;EACI,YAAY;EACZ,aAAa;EACb,sBAAsB;AAC1B;;AAEA;EACI,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;AACzB;;AAEA;EACI,mBAAmB;AACvB;;AAEA;EACI,gBAAgB;AACpB;;AAEA,yBAAyB;;AACzB;EACI,6BAA6B;AACjC;;AAEA;;;EAGI,6BAA6B;EAC7B,gCAAgC;EAChC,oCAAoC;EACpC,oCAAoC;AACxC;;AAEA;;;EAGI,gCAAgC;EAChC,oCAAoC;AACxC;;AAEA;;;EAGI,gCAAgC,EAAE,uBAAuB;EACzD,wDAAwD;EACxD,oCAAoC;AACxC;;AAEA,oDAAoD;;AACpD;EACI,WAAW;EACX,6BAA6B;EAC7B,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;AACnC;;AAEA,8BAA8B;;AAC9B;EACI,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AAC3B;;AAEA;EACI,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACzB;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACvB;;AAEA;EACI,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AAC3B;;AAEA;EACI,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACvB;;AAEA;EACI,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACnB;;AAEA,oBAAoB;;AACpB;EACI,aAAa;EACb,mBAAmB;EACnB,SAAS;AACb;;AAEA;EACI,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAClB;;AAEA;EACI,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AAChB","sourcesContent":[".view {\n    padding: 24px;\n    font-family: 'Inter', Roboto, Arial, sans-serif;\n}\n\n/* Typography and Layout Wrappers */\n.formWrapper {\n    margin-top: 24px;\n}\n\n.formCard {\n    background: #ffffff;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);\n    padding: 32px 24px;\n    height: 100%;\n    border: 1px solid #f1f5f9;\n}\n\n.mapCard {\n    background: #ffffff;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.05);\n    padding: 16px;\n    height: 100%;\n    min-height: 600px;\n    border: 1px solid #f1f5f9;\n    display: flex;\n    flex-direction: column;\n}\n\n.mapContainerWrap {\n    flex-grow: 1;\n    border-radius: 12px;\n    overflow: hidden;\n    /* Subtly separate the map from the white card */\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n    display: flex;\n    flex-direction: column;\n    min-height: 500px; /* Guarantee a minimum height */\n}\n\n.mapContainerWrap > div {\n    flex-grow: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.label {\n    font-size: 12px;\n    font-weight: 700;\n    color: #64748b;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    display: inline-block;\n}\n\n.itemColumn {\n    margin-bottom: 24px;\n}\n\n.itemSubmit {\n    margin-top: 32px;\n}\n\n/* Inputs customization */\n.input {\n    border-radius: 8px !important;\n}\n\n.input :global(.ant-select-selector),\n.input :global(.ant-input),\n.input:global(.ant-input-affix-wrapper) {\n    border-radius: 8px !important;\n    border-color: #cbd5e1 !important;\n    background-color: #f8fafc !important;\n    transition: all 0.2s ease !important;\n}\n\n.input :global(.ant-select-selector):hover,\n.input:global(.ant-input-affix-wrapper):hover,\n.input :global(.ant-input):hover {\n    border-color: #94a3b8 !important;\n    background-color: #ffffff !important;\n}\n\n.input :global(.ant-select-selector):focus,\n.input:global(.ant-input-affix-wrapper-focused),\n.input :global(.ant-input):focus {\n    border-color: #f97316 !important; /* Brand orange focus */\n    box-shadow: 0 0 0 2px rgba(249, 115, 22, 0.1) !important;\n    background-color: #ffffff !important;\n}\n\n/* Original Brand Button without gradients or neon */\n.submit {\n    width: 100%;\n    border-radius: 8px !important;\n    font-weight: 700 !important;\n    letter-spacing: 0.5px;\n    height: 48px !important;\n    font-size: 15px !important;\n    /* Keeping solid brand colors */\n}\n\n/* Secondary Button (Upload) */\n.uploadImage {\n    border-radius: 8px;\n    height: 38px;\n    padding: 0 16px;\n    font-weight: 600;\n    color: #f97316;\n    border: 1px solid #f97316;\n    background: transparent;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.uploadImage:hover {\n    color: #ffffff;\n    background: #f97316;\n    border-color: #f97316;\n}\n\n.mapActions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.exportBtn {\n    border-radius: 8px;\n    height: 38px;\n    padding: 0 16px;\n    font-weight: 600;\n    color: #64748b;\n    border: 1px solid #cbd5e1;\n    background: #ffffff;\n    transition: all 0.2s ease;\n    cursor: pointer;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.exportBtn:hover {\n    color: #334155;\n    border-color: #94a3b8;\n    background: #f8fafc;\n}\n\n.center {\n    display: block;\n    font-size: 12px;\n    color: #94a3b8;\n    margin-top: 8px;\n}\n\n/* Top bar actions */\n.actions {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.switchWrap {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-weight: 600;\n    color: #334155;\n}\n\n.loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 50vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"view": `ZoneUI_view__L2iU8`,
	"formWrapper": `ZoneUI_formWrapper__DsniZ`,
	"formCard": `ZoneUI_formCard__amgGL`,
	"mapCard": `ZoneUI_mapCard__-Hbvt`,
	"mapContainerWrap": `ZoneUI_mapContainerWrap__YvFAp`,
	"label": `ZoneUI_label__Mbpee`,
	"itemColumn": `ZoneUI_itemColumn__KjKRA`,
	"itemSubmit": `ZoneUI_itemSubmit__+qtuE`,
	"input": `ZoneUI_input__uMdO+`,
	"submit": `ZoneUI_submit__6u+cm`,
	"uploadImage": `ZoneUI_uploadImage__3GjPx`,
	"mapActions": `ZoneUI_mapActions__+S25L`,
	"exportBtn": `ZoneUI_exportBtn__WPjcu`,
	"center": `ZoneUI_center__D5dfS`,
	"actions": `ZoneUI_actions__O8xyn`,
	"switchWrap": `ZoneUI_switchWrap__UnQRw`,
	"loader": `ZoneUI_loader__NQB+9`
};
export default ___CSS_LOADER_EXPORT___;
